// extracted by mini-css-extract-plugin
module.exports = {"label":"Invitations_label__GEtzq","invitationContainer":"Invitations_invitationContainer__3XMhN","passwordInputStyle":"Invitations_passwordInputStyle__3Twhb"};